import Vue from 'vue';
import Component from 'vue-class-component';
import { postForm } from '@/utils/CrmHttp';
import load from '@/assets/images/upLoading.gif';
import QRCode from 'qrcode';
import { draw } from '@/utils/Draw';
import { PayTypeEnum } from '@/types/crm-enums';
import { toast } from '@/utils/utils';
@Component({

})
export default class Recharge extends Vue {
  /**
   * 充值
   */
  public load = load;
  public payLoad: boolean = false;
  public qrLoad: boolean = false;
  public moneyList: any[] = ['200', '500', '1000', '10000'];
  public amount: string = '200';
  public selectMoney: string = '0';
  public hintMsg: boolean = false;
  public rechargeWay: any[] = [];
  public downLoadMessage: string = '请长按选择保存到相册,然后用微信扫一扫打开';
  public downLoadFlage: boolean = true;
  public saveSuccess: boolean = false;
  // 选择支付方式
  public channelId: string = '';
  public channelSubId: string = '';
  public channelSubName: string = '';
  public activeItem: OnlinePayItemChannelModel = {} as any;
  public payType: number = 0;
  public method: string = '';
  // 选中支付方式
  public selectRecharge: string = '0';
  public downloadUrl: string = '';
  public imgUrl: string = '';
  // 显示二维码
  public hintImg: boolean = false;

  public async activated() {
    this.selectRecharge = '0';
    this.amount = '200';
    this.loadChannel();
    if (window.platform.name) {
      this.downLoadMessage = '请点击下载,保存到相册,然后用微信扫一扫打开';
      this.downLoadFlage = false;
    } else {
      this.downLoadMessage = '请长按选择保存到相册,然后用微信扫一扫打开';
      this.downLoadFlage = true;
    }
  }
  public handleDownload() {
    const that = this;
    const permissions = cordova.plugins.permissions;
    permissions.hasPermission(permissions.WRITE_EXTERNAL_STORAGE,
      function (status) {
        if (status.hasPermission) {
          cordova.base64ToGallery(
            (that.$refs.codes as any).toDataURL(),
            {
              prefix: 'img_',
              mediaScanner: true,
            },
            function (path) {
              that.saveSuccess = true;
              setTimeout(() => {
                that.saveSuccess = false;
              }, 2000);
            },
            function (err) {
              alert('保存失败,请重试');
            },
          );
        } else {
          permissions.requestPermission(permissions.WRITE_EXTERNAL_STORAGE,
            function (state) {
              if (state.hasPermission) {
                alert('获取权限成功,请重新点击下载图片');
              } else {
                alert('获取权限失败');
              }
            }, function (err) {
              alert(err);
            });
        }
      });
  }
  /**
   * namege
   */
  public getImgPath(path) {
    // return 'http://39.104.67.41:8001/img/pay/' + path;
    return crmAddress + '/img/pay/' + path;
  }
  public async loadChannel() {
    this.payLoad = true;
    const data = await postForm('/api/online-pay/query-mobile-channels', {});
    this.rechargeWay = data;
    if(process.env.NODE_ENV === 'development')
      console.log(this.rechargeWay);
    if (this.rechargeWay.length) {
      this.channelId = this.rechargeWay[0].ChannelId;
      this.channelSubId = this.rechargeWay[0].ChannelSubId;
      this.channelSubName = this.rechargeWay[0].ChannelSubName;
      this.activeItem = this.rechargeWay[0];
      this.payType = this.rechargeWay[0].PayType;
      this.method = this.rechargeWay[0].Method;
    } else {
      toast('没有支付渠道');
    }
    this.payLoad = false;
  }
  // 选择已有金额
  public handleSelect(item, index) {
    this.selectMoney = index;
    this.amount = item;
  }
  // 选择支付方式
  public handleWay(item, index) {
    this.selectRecharge = index;
    if(process.env.NODE_ENV === 'development')
      console.log(item);
    this.channelId = item.ChannelId;
    this.channelSubId = item.ChannelSubId;
    this.channelSubName = item.ChannelSubName;
    this.activeItem = item;
    this.payType = item.PayType;
    this.method = item.Method;
    this.imgUrl = item.Img;
  }
  // 立即充值
  public async handleEnter() {
    if (!Number(this.amount)) {
      this.hintMsg = true;
      setTimeout(() => {
        this.hintMsg = false;
      }, 1500);
      return;
    } else {
      const data = await postForm('/api/online-pay/' + this.method, {
        ChannelId: this.channelId,
        ConfigId: this.activeItem.ConfigId,
        ChannelSubId: this.channelSubId,
        ChannelSubName: this.channelSubName,
        Money: this.amount,
        PayType: this.payType,
      }) as TransferInModel;
      if(process.env.NODE_ENV === 'development')
        console.log(data);
      this.qrLoad = false;
      switch (this.payType) {
        case PayTypeEnum.Qr:
        case PayTypeEnum.WeixinPublic:
          this.drawQr(data.OnlinePayUrl);
          break;
        case PayTypeEnum.AliCall:
        case PayTypeEnum.OpenUrl:
          this.openPayUrl(data.OnlinePayUrl);
          break;
      }
    }
  }
  public async drawQr(payUrl) {
    try {
      await draw(
        this.$refs.codes,
        this.channelSubName,
        payUrl,
        crmAddress + '/img/pay/' + this.imgUrl,
        // 'http://39.104.67.41:8001/img/pay/' + this.imgUrl,
        this.channelSubName,
        this.amount,
      );
      this.hintImg = true;
      this.downloadUrl = (this.$refs.codes as any).toDataURL();
    } catch (e) {
      console.error(e);
    }
  }
  public async openPayUrl(payUrl) {
    // 是苹果或安卓 app
    if (window.platform.name) {
      cordova.InAppBrowser.open(payUrl, '_system');
    } else {
      window.location.href = payUrl;
    }
  }
  public handleCloseQr() {
    this.hintImg = false;
    this.goback();
  }

  // 返回
  public goback() {
    this.$router.go(-1);
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/Recharge/Recharge.ts